function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);
document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.join-membership-atc')?.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('#add-membership-btn').click();
  });
});
// Enavi Cashback in Sidecart and 41-2-R-CART-Subscription VPs //
function checkAndHandleUpsell(forceload) {
  let upsellExists = document.querySelector(".boost-cart-upsell-membership");
  let upsellCartItem = document.querySelector(".boost-cart__item")?.getAttribute('data-sku');
  if (upsellCartItem === "CS-HUNT" && upsellExists) {
      upsellExists = false;
  }
  let subtotalElement = document.querySelector(".boost-cart__subtotal");
  let totalElement = document.querySelector(".boost-cart__total");
  if (!subtotalElement || !totalElement) return;

  let existingDiv = document.querySelector(".cashback-data-block");
  
  if (!forceload) {
      if ((!upsellExists && existingDiv?.classList.contains("already-member")) ||
          (upsellExists && existingDiv?.querySelector(".membership-btn"))) {
          return;
      }
  }
  if (existingDiv) existingDiv.remove();
  let newDiv = document.createElement("div");
  newDiv.classList.add("cashback-data-block");
  var cashbackprice = ((document.querySelector('.boost-cart__total').textContent.match(/\$([\d.]+)/)?.[1]));
  var memberprice = document.querySelector('.boost-cart__item[data-sku="CS-HUNT"] .boost-cart__item-price')? document.querySelector('.boost-cart__item[data-sku="CS-HUNT"] .boost-cart__item-price').textContent.match(/\$([\d.]+)/)?.[1]: 0;
    cashbackprice -= memberprice;
  if(cashbackprice > 0){
    cashbackprice = (cashbackprice*0.05).toFixed(2);
    if (!upsellExists) {
        newDiv.classList.add("already-member");
        newDiv.innerHTML = `
            <span class="cashback-text">Cashback</span>
            <span class="cashback-data">
                <span class="membership-price">$${cashbackprice}</span>
            </span>`;
    } else {
        newDiv.innerHTML = `
            <span class="cashback-text">Cashback</span>
            <span class="cashback-data">
                <span class="membership-btn">Join Membership</span>
                <span class="membership-price">$${cashbackprice}</span>
            </span>`;
    }
    
    subtotalElement.parentNode.insertBefore(newDiv, subtotalElement);
    
    let membershipBtn = newDiv.querySelector(".membership-btn");
    if (membershipBtn) {
        membershipBtn.addEventListener("click", () => {
            document.querySelector(".boost-cart-upsell-membership button")?.click();
        });
    }
}
}
function wrapSubscriptionTooltipContent(forceload) {
  document.querySelectorAll('.boost-cart__item-subscription').forEach(item => {
    const titleEl = item.querySelector('.boost-cart__item-subscription-tooltip-title');
    if (!titleEl) return;

    // Prevent duplicate updates unless forced
    if (!forceload && titleEl.classList.contains('custom-enhanced')) return;

    // Update and inject HTML
    titleEl.innerHTML = `
      <label class="custom-checkbox subscription-toggle-checkbox">
    <input type="checkbox">
    <span class="checkmark"></span>
      <span class="subscription-label-content">Subscribe & Save 10%
      <small>Change or cancel anytime.</small>
      </span>
      </label>
      <div class="subscription-details">
      <img src="https://cdn.shopify.com/s/files/1/0066/9905/7223/files/image_73.png?v=1755798941" class="info-icon"/>
        <ul class="subscription-list"><li><div class="boost-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none" viewBox="0 0 12 13"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 7.83255 4.4632 11.404c1.62966-4.68132 2.98686-6.73553 6.0606-9.52384"></path></svg></div><span>Save 10% on all orders<br/>(15% when you add 5+ items)</span></li><li><div class="boost-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none" viewBox="0 0 12 13"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 7.83255 4.4632 11.404c1.62966-4.68132 2.98686-6.73553 6.0606-9.52384"></path></svg></div><span>Change or cancel anytime</span></li><!----></ul>
      </div>
    `;

    titleEl.classList.add('custom-enhanced');
    const checkbox = titleEl.querySelector('.subscription-toggle-checkbox');
    checkbox?.addEventListener('click', () => {
      const switchEl = item.closest('.boost-cart__item')?.querySelector('.boost-cart__item-subscription-switch');
      if (switchEl) switchEl.click();
    });
  });
}
const targetNode = document.querySelector("#boost-cart-app");
if (targetNode) {
  const observer = new MutationObserver((mutations) => {
      if (mutations.some(mutation => mutation.type === "childList")) {
          setTimeout(function(){
            checkAndHandleUpsell(false)
            wrapSubscriptionTooltipContent(false)
          },200)
      }
  });
  observer.observe(targetNode, { childList: true, subtree: true });
}

setTimeout(function(){
  checkAndHandleUpsell(false)
  wrapSubscriptionTooltipContent(false)
},300)

const originalFetch = window.fetch;
window.fetch = async function (...args) {
  const response = await originalFetch.apply(this, args);
  if (args[0].includes('/api.boost.shop/storefront/cart/items') || args[0].includes('/cart/change.js')) {
      response.clone().json().then(() => {
          setTimeout(function(){
            checkAndHandleUpsell(true)
            wrapSubscriptionTooltipContent(true)
          },1000)
          setTimeout(function(){
            checkAndHandleUpsell(true)
            wrapSubscriptionTooltipContent(true)
          },2000)
      });
  }
  return response;
};

const originalXHR = window.XMLHttpRequest.prototype.open;
window.XMLHttpRequest.prototype.open = function (method, url) {
  if (url.includes('/api.boost.shop/storefront/cart/items') || url.includes('/cart/change.js')) {
    setTimeout(function(){
      checkAndHandleUpsell(true)
      wrapSubscriptionTooltipContent(true)
    },1000)
    setTimeout(function(){
      checkAndHandleUpsell(true)
      wrapSubscriptionTooltipContent(true)
    },2000)
  }
  return originalXHR.apply(this, arguments);
};
// Enavi Cashback in Sidecart and 41-2-R-CART-Subscription VPs //

// Enavi Quick Filters //
document.addEventListener('DOMContentLoaded', () => {
  if(window.innerWidth <=768){
    const topBar = document.querySelector('.rtnu-collection__top-bar');
    const enaviFilters = document.querySelector('.enavi-filters');
    if (topBar && enaviFilters) {
        var header = document.querySelector('.main-header-section');
        var stickyFilter = document.querySelector('.rtnu-collection__top-bar.sticky-filter');
        if (header && stickyFilter) {
          var headerHeight = header.offsetHeight;
          stickyFilter.style.top = headerHeight + 'px';
        }
    }
    document.querySelectorAll('.enavi-filters .rtnu-collection__filter').forEach(filterEl => {
      filterEl.addEventListener('click', function () {
        const filterValue = this.getAttribute('data-filter');
        this.classList.toggle('active');
        const targetFilter = document.querySelector(`.rtnu-collection__filters .rtnu-collection__filter[data-filter="${filterValue}"]`);
        if (targetFilter) {
          targetFilter.click();
        }
      });
    });
  }
})
// Enavi Quick Filters //
